// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2xNCp","title":"Info_title__3BwOH","links":"Info_links__R-q9T","link":"Info_link__cWgp9","logo":"Info_logo__O6XEU"};